class AppEventEmitter extends EventTarget {
    emit( name: string, ...args: unknown[] ): void {
        this.dispatchEvent( new CustomEvent( name, { detail: args } ) );
    }

    on( name: string, callback: ( ...args: any[] ) => void ): void {
        const handler = ( ( event: CustomEvent ) => {
            callback( ...( event.detail || [] ) );
        } ) as EventListener;
        ( callback as any ).__etHandler = handler;
        this.addEventListener( name, handler );
    }

    removeListener( name: string, callback: ( ...args: any[] ) => void ): void {
        const handler = ( callback as any ).__etHandler as EventListener | undefined;
        if ( handler ) {
            this.removeEventListener( name, handler );
            delete ( callback as any ).__etHandler;
        }
    }
}

const appEventEmitter = new AppEventEmitter();

const events = {
    HEADER_CHANGE_IMAGE: 'headerChangeImage',
};

export { appEventEmitter as default, events };
